import { gql, useApolloClient } from "@apollo/client";
import { DeleteMembershipTierBusinessFragmentDoc, useDeleteMembershipTierMutation, } from "../types";
gql `
  fragment DeleteMembershipTierBusiness on MembershipTier {
    id
    business {
      id
    }
  }

  mutation DeleteMembershipTier($id: ID!) {
    membershipTierDestroy(id: $id) {
      ...DeleteMembershipTierBusiness
    }
  }
`;
export const useDeleteMembershipTier = (id) => {
    const client = useApolloClient();
    const [deleteMembershipTier, result] = useDeleteMembershipTierMutation();
    // KGAUDIT - not sure how this works
    const wrappedFunction = (...args) => {
        // KGAAUDIT - wouldn't this be... an undeleted one?
        const optimisticResponse = client.readFragment({
            id: `MembershipTier:${id}`,
            fragment: DeleteMembershipTierBusinessFragmentDoc,
        });
        return deleteMembershipTier(Object.assign(Object.assign({}, args), { variables: { id }, optimisticResponse: {
                membershipTierDestroy: optimisticResponse,
            }, update: (cache, { data }) => {
                var _a, _b;
                const businessId = (_b = (_a = data === null || data === void 0 ? void 0 : data.membershipTierDestroy) === null || _a === void 0 ? void 0 : _a.business) === null || _b === void 0 ? void 0 : _b.id;
                cache.modify({
                    id: `Business:${businessId}`,
                    fields: {
                        // KGAUDIT - Not sure how this works, but I get that it's removing the thing.
                        membershipTiers(existingMembershipTierRefs = [], { readField }) {
                            return existingMembershipTierRefs.filter((ref) => readField("id", ref) !== id);
                        },
                    },
                });
            } }));
    };
    return { wrapped: wrappedFunction, original: deleteMembershipTier, result };
};
